import React from 'react';

const Faq = () => {
    return (
        <div>
            <h2 className='text-5xl font-semibold text-center my-56'>Coming........</h2>
        </div>
    );
};

export default Faq;